import {
  Alert,
  Dialog,
  Stack,
  TextField,
} from '@all-manager/design-system-v2';
import { Controller } from 'react-hook-form';
import RoleField from '../RoleField/RoleField';
import useAddMemberModal from './useAddMemberModal';

type Props = {
  spaceId: string;
  onClose: () => void;
};

export default function AddMemberModal(props: Props) {
  const hook = useAddMemberModal({
    spaceId: props.spaceId,
    onClose: props.onClose,
  });

  return (
    <Dialog
      open
      onClose={props.onClose}
      onSubmit={hook.onSubmit}
      maxWidth="sm"
      fullWidth
      title="Ajouter un membre"
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: 'Ajouter',
          type: 'submit',
          loading: hook.isSubmitting,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: props.onClose,
          disabled: hook.isSubmitting,
        },
      }}
    >
      <Stack spacing={2}>
        {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}

        <Controller
          name="firstName"
          control={hook.form.control}
          render={({ field, fieldState }) => (
            <TextField
              name={field.name}
              inputRef={field.ref}
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value}
              label="Prénom"
              autoFocus
              required
              fullWidth
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />
        <Controller
          name="lastName"
          control={hook.form.control}
          render={({ field, fieldState }) => (
            <TextField
              name={field.name}
              inputRef={field.ref}
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value}
              label="Nom"
              required
              fullWidth
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />

        <Controller
          name="email"
          control={hook.form.control}
          render={({ field, fieldState }) => (
            <TextField
              name={field.name}
              inputRef={field.ref}
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value}
              label="Email"
              type="email"
              autoComplete="off"
              required
              fullWidth
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />

        <Controller
          name="role"
          control={hook.form.control}
          render={({ field }) => (
            <RoleField
              name={field.name}
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
            />
          )}
        />
      </Stack>
    </Dialog>
  );
}
